import {
  getSSMClient,
  newParameterStoreService,
  newParameterValueService,
  newSSMParameterRepository,
} from '@nucleus/lib-parameter-store';
import { NameGeneratorFactory } from './stage';

const SSMParameterRepository = newSSMParameterRepository(getSSMClient());

const PlatformParameterStoreService = newParameterStoreService(SSMParameterRepository, {
  nameGenerator: NameGeneratorFactory('NucleusPlatformResources'),
});

/**
 * SSM Parameter: The shared API Gateway URL used by MOST services.
 */
export const ApiGatewayRestApiUrl = newParameterValueService(PlatformParameterStoreService, 'ApiGatewayRestApiUrl');

/**
 * SSM Parameter: The Cognito client ID of the Nucleus Dashboard.
 */
export const NucleusDashboardAppClientId = newParameterValueService(
  PlatformParameterStoreService,
  'NucleusDashboardAppClientId'
);

/**
 * SSM Parameter: The Cognito client ID of the Rebel Give App Client.
 */
export const RebelGiveAppClientId = newParameterValueService(PlatformParameterStoreService, 'RebelGiveAppClientId');

/**
 * SSM Parameter: The name of the generic asset bucket.
 * This bucket is private and only accessible by the services in the Nucleus Platform.
 *   With the exception of the /uploads/ folder, which is publicly accessible. It's a legacy folder that is used to store assets like profile images.
 */
export const AssetBucketName = newParameterValueService(PlatformParameterStoreService, 'AssetBucketName');

/**
 * SSM Parameter: The name of the user content bucket.
 * This bucket is private and only accessible by the services in the Nucleus Platform.
 * It is used to store content uploaded by users.
 */
export const UserContentBucketName = newParameterValueService(PlatformParameterStoreService, 'UserContentBucketName');

/**
 * SSM Parameter: The name of the user content processed bucket.
 * This bucket is private and only accessible by the services in the Nucleus Platform.
 * It is used to store the result of processing content uploaded by users into the user content bucket.
 */
export const UserContentProcessedBucketName = newParameterValueService(
  PlatformParameterStoreService,
  'UserContentProcessedBucketName'
);
